import { VillageVirtualOfficesComponent } from './pages/village-virtual-offices/village-virtual-offices.component';
import { VillageVirtualOfficeLinks } from './../../core/services/village-virtual-office-links.service';
import { VillageContactSettingsResolver } from './resolvers/village-contact-settings.resolver';
import { VillageContactSettingsComponent } from './pages/village-contact-settings/village-contact-settings.component';
import { VillageVideoItemsComponent } from './pages/village-video-items/village-video-items.component';
import { TransportationFacilitiesSettingsResolver } from './resolvers/transportation-facilities-settings.resolver';
import { InitiativesComponent } from './pages/initiatives/initiatives.component';
import { GovernmentOfficesSettingsComponent } from './pages/government-offices-settings/government-offices-settings.component';
import { PublicPlacesComponent } from './pages/public-places/public-places.component';
import { PublicPlacesSettingsResolver } from './resolvers/public-places-settings.resolver';
import { AboutUsComponent } from './pages/about-us/about-us.component';
import { GovernanceSettingsResolver } from './resolvers/governance-settings.resolver';
import { VillageGovernanceComponent } from './pages/village-governance/village-governance.component';
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { HomeComponent } from './pages/home/home.component';
import { IndexComponent } from './pages/index/index.component';
import { AboutVillageSettingsResolver } from './resolvers/about-village-settings.resolver';
import { GovernmentOfficesSettingsResolver } from './resolvers/government-offices-settings.resolver';
import { InitiativesSettingsResolver } from './resolvers/initiatives-settings.resolver';
import { TransportationFacilitiesSettingsComponent } from './pages/transportation-facilities-settings/transportation-facilities-settings.component';
import { EventsSettingsResolver } from './resolvers/events-settings.resolver';
import { EventsSettingsComponent } from './pages/events-settings/events-settings.component';
import { AboutComponent } from './pages/about/about.component';

const routes: Routes = [
  {
    path: '',
    component: HomeComponent,
    pathMatch: 'prefix',
    children: [
      {
        path: '',
        redirectTo: 'index',
        pathMatch: 'full'
      },
      {
        path: 'index',
        component: IndexComponent
      },

      { path: 'governance_settings', redirectTo: 'governance_settings/grampanchayat', pathMatch: 'full' },
      {
        path: 'governance_settings/:id',
        resolve: {
          villageGovernance: GovernanceSettingsResolver
        },
        component: VillageGovernanceComponent
      },

      { path: 'about_village_settings', redirectTo: 'about_village_settings/profile', pathMatch: 'full' },
      {
        path: 'about_village_settings/:id',
        resolve: {
          aboutVillage: AboutVillageSettingsResolver
        },
        component: AboutUsComponent
      },
      { path: 'public_places_settings', redirectTo: 'public_places_settings/mosques', pathMatch: 'full' },
      {
        path: 'public_places_settings/:id',
        resolve: {
          publicPlaces: PublicPlacesSettingsResolver
        },
        component: PublicPlacesComponent
      },
      { path: 'government_offices_settings', redirectTo: 'government_offices_settings/grampanchayat', pathMatch: 'full' },
      {
        path: 'government_offices_settings/:id',
        resolve: {
          governmentOfficesSettings: GovernmentOfficesSettingsResolver
        },
        component: GovernmentOfficesSettingsComponent
      },
      { path: 'initiatives_settings', redirectTo: 'initiatives_settings/various_development_works_status', pathMatch: 'full' },
      {
        path: 'initiatives_settings/:id',
        resolve: {
          initiativesSettings: InitiativesSettingsResolver
        },
        component: InitiativesComponent
      },
      { path: 'transportation_facilities_settings', redirectTo: 'transportation_facilities_settings/roads', pathMatch: 'full' },
      {
        path: 'transportation_facilities_settings/:id',
        resolve: {
          transportationFacilitiesSettings: TransportationFacilitiesSettingsResolver
        },
        component: TransportationFacilitiesSettingsComponent
      },
      { path: 'events_settings', redirectTo: 'events_settings/religious_celebrations', pathMatch: 'full' },
      {
        path: 'events_settings/:id',
        resolve: {
          eventsSettings: EventsSettingsResolver
        },
        component: EventsSettingsComponent
      },
      { path: 'village_contact_settings', redirectTo: 'village_contact_settings/how_to_reach', pathMatch: 'full' },
      {
        path: 'village_contact_settings/:id',
        resolve: {
          villageContactSettings: VillageContactSettingsResolver
        },
        component: VillageContactSettingsComponent
      },
      {
        path: 'village_video_items',
        component: VillageVideoItemsComponent
      },
      {
        path: 'village_virtual_offices',
        component: VillageVirtualOfficesComponent
      },
      { path: 'About', redirectTo: 'About/profile', pathMatch: 'full'  },
      {
        path: 'About/:id',
        resolve: {
          aboutVillage: AboutVillageSettingsResolver
        },
        component: AboutComponent
      },

    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class HomeRoutingModule { }
